import UsersRepository from './user/userRepository';
import GroupsRepository from './groups/groupsRepository';
import SalonsRepository from './salons/salonsRepository';
import WeatherRepository from './weather/weatherRepository';
import DataRepository from './data/dataRepository';
import DevicesRepository from './devices/devicesRepository';
import ConfigurationRepository from './configuration/ConfigurationRepository';

const repositories = {
  users: UsersRepository,
  groups: GroupsRepository,
  salons: SalonsRepository,
  weather: WeatherRepository,
  data: DataRepository,
  devices: DevicesRepository,
  configuration: ConfigurationRepository,
};
// eslint-disable-next-line import/prefer-default-export
export const RepositoryFactory = {
  get: name => repositories[name],
};
